var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.form_id && _vm.submission_id)?_c('FormViewSubmission',{attrs:{"formid":_vm.form_id,"submissionid":_vm.submission_id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }